import axios from "axios"
import { getCookie } from "cookies-next"

const ConfiguredAppAxiosWithCtx = (appAxios, reqRes) => {
	var appAxiosCtx
	if(reqRes) {
	
		let result = getCookie('electy-server@auth-token', reqRes)
		
		var token = JSON.parse(result)?.token
		appAxiosCtx = axios.create({
			baseURL: process.env.NEXT_PUBLIC_APP_API_URL,
			timeout: 10000,
			// withCredentials: true,
			headers: {
				"Content-Type": "application/json",
			},
		})
	
		appAxiosCtx.interceptors.request.use(config => {
			try {
				let user = getCookie('electy-server@auth-token', reqRes)
				const token = JSON.parse(user)?.token
				if(token) {
					config.headers["Authorization"] = `Bearer ${token}`
				}
			} catch (error) { console.log('not token') }
			return config
		})
	} else {
		appAxiosCtx = appAxios
	}
	return appAxiosCtx
}

export default ConfiguredAppAxiosWithCtx;